import { ReactElement } from 'react';

import { RdPathLoader, AccountingQreLayout } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { useAccountingQresRedirect } from './hooks';

export const AccountingQres = (): ReactElement => (
  <RdPathLoader path={Path.ACCOUNTING_QRE} useRedirect={useAccountingQresRedirect}>
    <AccountingQreLayout />
  </RdPathLoader>
);
